import agencyCommissionApi from 'api/agencyCommissionApi';
import imgEmptyThanhToan from 'assets/images/img_emptyview_thanh_toan.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import CommissionTransactionHelper from 'features/ManageCommissionTransaction/commissionTransactionHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import AgencyHelper from 'features/Agency/agencyHelper';

CommissionTransactionListScreen.propTypes = {};

const defaultColumnIds = [
  'TRANSACTION_CODE',
  'BANK_BENEFICIARY',
  'ROLE',
  'DESCRIPTION',
  'AMOUNT',
  'BALANCE',
  'STATUS',
  'TIME',
];

function CommissionTransactionListScreen(props) {
  // ---- params ----
  const router = useRouter();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'TRANSACTION_CODE',
        name: UIHelper.buildTableColumn('Mã giao dịch'),
        selector: (row) => row?.agencyTransactionCode ?? row?.agencyTransactionId,
        style: tableStyle.columns.normal,
        width: '120px',
      },
      {
        id: 'BANK_BENEFICIARY',
        name: UIHelper.buildTableColumn('Người thụ hưởng'),
        selector: (row) => {
          return (
            <KTTooltip offset={[0, 0]} text={row?.agency?.name ?? ''}>
              <span
                onClick={() => {
                  if (row?.agency?.primaryRole === AppConstants.userAgencyType.sale)
                    Utils.openInNewTab(`${AppRoute.saleList}/${row?.agencyId}`);
                  else if (row?.agency?.primaryRole === AppConstants.userAgencyType.investor)
                    Utils.openInNewTab(`${AppRoute.investorList}/${row?.agencyId}`);
                  else if (row?.agency?.primaryRole === AppConstants.userAgencyType.group)
                    Utils.openInNewTab(`${AppRoute.groupList}/${row?.agencyId}`);
                  else Utils.openInNewTab(`${AppRoute.landlordList}/${row?.agencyId}`);
                }}
              >
                {row?.agency?.name ?? 'N/A'}
              </span>
            </KTTooltip>
          );
        },
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'ROLE',
        name: UIHelper.buildTableColumn('Vai trò'),
        selector: (row) => row?.forRole
          ? row?.forRole === 'WITHDRAW'
            ? 'Rút tiền'
            : t(`agencyRoleDropdownTitle_${row?.forRole}`)
          : '',
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'DESCRIPTION',
        name: UIHelper.buildTableColumn('Mô tả'),
        selector: (row) => row?.description,
        minWidth: '500px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: UIHelper.buildTableColumn('Số tiền', 'VNĐ'),
        selector: (row) => (row?.amount > 0 ? '+' + Utils.formatNumber(row?.amount) : Utils.formatNumber(row?.amount)),
        width: '160px',
        right: true,
        style: tableStyle.columns.link,
      },
      {
        id: 'BALANCE',
        name: UIHelper.buildTableColumn('Số dư ví', 'VNĐ'),
        selector: (row) => (row?.endingBalance ? Utils.formatNumber(row?.endingBalance ?? 0) : 0),
        width: '160px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng tháI'),
        selector: (row) => (
          <KTLabel
            text={AgencyHelper.Utils.getSaleOrderStatusName(row?.status ?? 'COMPLETED')}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${AgencyHelper.Utils.getSaleOrderStatusColor(
              row?.status ?? 'COMPLETED'
            )}`}
          />
        ),
        width: '150px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'TIME',
        name: UIHelper.buildTableColumn('Thời gian'),
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
        width: '160px',
        style: tableStyle.columns.normal,
      },
    ];
  }, [t]);
  const { isGettingData, commissionTransactionList, total } = useSelector(
    (state) => state.commissionTransaction
  );
  const [filter, setFilter] = useState(Global.g_filterCommissionTransactionList);
  const [filterDropdown, setFilterDropdown] = useState(Global.g_filterCommissionTransactionList);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = `${router.pathname}${router.location.hash}`;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    saveChanges,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  // ---- methods ----

  useEffect(() => {
    getDealerList();
  }, [filter]);

  const getDealerList = () => {
    try {
      CommissionTransactionHelper.callApiGetAgencyTransactionList(filter);
    } catch (error) {
      console.error('Error while getting dealer list:', error);
    }
  };

  // xuat file excel
  const handleExportExcel = async (exportData, params) => {
    let exportDataList = exportData;
    if (_.isEmpty(exportDataList)) {
      ToastHelper.showError('Không có dữ liệu để tải xuống');
      return;
    }

    const sheetFileName = 'Chi_trả_hoa_hồng_và_doanh_thu_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
    const ext = '.xlsx';
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(sheetFileName, {
      headerFooter: { firstHeader: sheetFileName },
    });

    sheet.mergeCells('A1:J1');
    sheet.getCell('A1').value = `DANH SÁCH CHI TRẢ HOA HỒNG & DOANH THU (NGÀY ${moment(params.from).format(
      'DD/MM/YYYY'
    )} - ${moment(params.to).format('DD/MM/YYYY')})`;
    sheet.getCell('A1').font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: 'FFFFFFFF' },
    };
    sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    sheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '29618E' },
      color: { argb: 'FFFFFF' },
    };
    sheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    sheet.getRow(1).height = 25;

    const columns = [
      { key: 'stt', width: 7 },
      { key: 'transactionCode', width: 18 },
      { key: 'beneficiary', width: 25 },
      { key: 'role', width: 22 },
      { key: 'agencyCode', width: 22 },
      { key: 'description', width: 30 },
      { key: 'amount', width: 22 },
      { key: 'balance', width: 22 },
      { key: 'status', width: 15 },
      { key: 'time', width: 20 },
    ];
    sheet.columns = columns;

    sheet.getRow(2).height = 30;
    sheet.getRow(2).font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
    };
    sheet.getRow(2).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };

    sheet.getCell('A2').value = 'STT';
    sheet.getCell('B2').value = 'Mã phiên sạc';
    sheet.getCell('C2').value = 'Người thụ hưởng';
    sheet.getCell('D2').value = 'Vai trò';
    sheet.getCell('E2').value = 'Mã đối tác';
    sheet.getCell('F2').value = 'Mô tả';
    sheet.getCell('G2').value = 'Số tiền (VNĐ)';
    sheet.getCell('H2').value = 'Số dư ví (VNĐ)';
    sheet.getCell('I2').value = 'Trạng thái';
    sheet.getCell('J2').value = 'Thời gian';


    ['A2:J2'].forEach((range) => {
      sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    let i = 1;
    exportDataList?.forEach((row) => {
      const dataRow = sheet.addRow({
        stt: i++,
        transactionCode: row?.agencyTransactionCode ?? row?.agencyTransactionId,
        beneficiary: row?.agency?.name,
        role: row?.forRole ? row?.forRole === 'WITHDRAW' ? 'Rút tiền' : t(`agencyRoleDropdownTitle_${row?.forRole}`) : '',
        agencyCode: row?.agencyId,
        description: row?.description,
        amount: Utils.formatNumber(row?.amount ?? 0),
        balance: Utils.formatNumber(row?.endingBalance ?? 0),
        status: 'Hoàn thành',
        time: Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
      });

      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (colNumber === 1) {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (colNumber >= 7 && colNumber <= 8) {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        }
      });
    });

    sheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 3) {
        row.font = {
          name: 'Times New Roman',
          family: 4,
          size: 11,
          bold: false,
        };
      }
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetFileName + ext;
      anchor.click();
      window.URL.revokeObjectURL(url);
      ToastHelper.showSuccess('Tải xuống file Excel thành công');
      AppCustomDialogHelper.hide();
    });
  };

  return (
    <div>
      <KTBSCard
        borderRadius="10"
        title={t('Chi trả hoa hồng & doanh thu')}
        description={
          <div>
            <span
              className="font-weight-bolder"
              style={{ fontSize: '14px', color: AppColors.gray[800] }}
            >
              {t('total')}:{' '}
            </span>
            <span
              className="font-weight-bolder"
              style={{ fontSize: '14px', color: AppColors.primary }}
            >
              {total != 0 ? total : commissionTransactionList?.length}{' '}
              {t('giao dịch').toLowerCase()}
            </span>
          </div>
        }
        additionalHeaderClassName="pt-4 pb-2"
        additionalBodyClassName="py-0"
        additionalFooterClassName=""
        hideDividerHeader
        hideDividerFooter
        toolbar={
          <div className="d-flex align-items-center">
            {UIHelper.buildBlueButton(
              'Tải xuống',
              async () => {
                try {
                  ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                    ChargeHelper.Filter.chargeTransactionList,
                    async (params) => {
                      try {
                        const { transactions = [] } = await agencyCommissionApi.getAgencyCommissionTransactions(params);
                        return handleExportExcel(transactions, params);
                      } catch (error) {
                        ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                        return [];
                      }
                    },
                  );
                } catch (error) {
                  ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                }
              },
              <i className="fa-regular fa-download" style={{ fontSize: 15 }} />
            )}
          </div>
        }
        subToolbar={
          <div className="w-100 d-flex align-items-end flex-wrap">
            <div className="col-lg-3 col-sm-6 px-0 pr-sm-4 py-2">
              <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                {t('search')}
              </label>
              <KTFormSearch
                name="search-bar"
                placeholder={t('Theo mã giao dịch, người thụ hưởng...')}
                value={Global.g_filterCommissionTransactionList.q}
                onSubmit={(text) => {
                  Global.g_filterCommissionTransactionList = {
                    ...Global.g_filterCommissionTransactionList,
                    q: text,
                  };
                  setFilter(Global.g_filterCommissionTransactionList);
                }}
              />
            </div>
            <div className="col-lg-3 col-sm-6 px-0 pr-lg-4 py-2">
              <label htmlFor="operator" className="mb-0 mr-2 font-weight-bolder">
                {t('Vai trò')}
              </label>
              <KTBSDropdown
                toggleElement={
                  <button
                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    type="button"
                  >
                    {Global.g_filterCommissionTransactionList.forRole
                      ? t(`agencyRoleDropdownTitle_${Global.g_filterCommissionTransactionList.forRole}`)
                      : t('all')}
                  </button>
                }
                selectedValue={Global.g_filterCommissionTransactionList.forRole}
                dropdownMenuItems={CommissionTransactionHelper.filterRoleOptions()}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  Global.g_filterCommissionTransactionList = {
                    ...Global.g_filterCommissionTransactionList,
                    forRole: value,
                  };
                  setFilter(Global.g_filterCommissionTransactionList);
                }}
                isDropdownForm={true}
              />
            </div>
            {/* khoang thoi gian */}
            <div className="col-lg-3 col-sm-6 px-0 pr-sm-4 py-2">
              <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                {t('filterByDate')}
              </label>
              <CustomDateRangePicker
                toggleElementBorderRadius={5}
                alignRight={true}
                initialValue={
                  Global.g_filterCommissionTransactionList.selectedValue?.length > 0
                    ? Global.g_filterCommissionTransactionList.selectedValue
                    : dateFilter.baMuoiNgayGanNhat
                }
                onPressSave={(selectedValue, startDate, endDate) => {
                  Global.g_filterCommissionTransactionList = {
                    ...Global.g_filterCommissionTransactionList,
                    from: startDate,
                    to: endDate,
                    selectedValue: selectedValue,
                  };
                  setFilter(Global.g_filterCommissionTransactionList);
                }}
                filterComponent={Global.g_filterCommissionTransactionList}
              />
            </div>

            {/* cau hinh cot */}
            <div className="pr-0 py-2">
              <DropdownTableConfigColumn
                columnIds={columnIds}
                fullColumns={fullColumns}
                fullColumnIds={fullColumnsIdSorted}
                onChangeCheckboxValue={onChangeCheckboxValue}
                saveChanges={saveChanges}
                resetDefaultTableColumn={() => {
                  setFullColumnIds(defaultColumnIds);
                  resetDefaultTableColumn();
                }}
                onChangeFullColumnIds={(ids) => {
                  setFullColumnIds(ids);
                  const key = prefKey + '_FULL_COLUMN_IDS';
                  localStorage.setItem(key, ids.join('|'));
                }}
                onSelectAll={onSelectAll}
                onUnSelectAll={onUnSelectAll}
              />
            </div>
          </div>
        }
        footer={
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={total != 0 ? total : commissionTransactionList?.length}
            rowsPerPage={filter.limit}
            currentItemInPageCount={commissionTransactionList?.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              Global.g_filterCommissionTransactionList = {
                ...Global.g_filterCommissionTransactionList,
                page: iNewPage - 1,
              };
              setFilter(Global.g_filterCommissionTransactionList);
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              Global.g_filterCommissionTransactionList = {
                ...Global.g_filterCommissionTransactionList,
                limit: iNewRowsPerPage,
                page: 0,
              };
              setFilter(Global.g_filterCommissionTransactionList);
            }}
            loading={isGettingData}
            color={KTPaginationColor.success}
            appendText="giao dịch"
          />
        }
        body={
          <KTTable
            columns={columns}
            items={commissionTransactionList}
            selectableRows={false}
            striped={false}
            compactGrid={false}
            onClickedRow={(row) => { }}
            onSelectedRowsChanged={(rows) => { }}
            onDoubleClickedRow={(rows) => { }}
            hasActionColumn={false}
            noDataComponent={
              <EmptyView
                icon={imgEmptyThanhToan}
                title="Không có dữ liệu để hiển thị"
                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
              />
            }
          />
        }
      />
    </div>
  );
}

export default CommissionTransactionListScreen;
